export default "__VITE_ASSET__d680f18e__"